import { Dropzone, MIME_TYPES } from '@mantine/dropzone';
import { Box, Text, Button, Stack, rem } from '@mantine/core';
import { IconUpload, IconDownload } from '@tabler/icons-react';
import { notifyError } from './Toast';

export const DropzoneButton = ({ onDrop }) => {
  const handleReject = (files) => {
    files.forEach((file) => {
      if (file.errors.some(error => error.code === 'file-too-large')) {
        notifyError('El archivo no puede ser mayor a 10 megabytes');
      } else if (file.errors.some(error => error.code === 'file-invalid-type')) {
        notifyError('El archivo principal debe ser un PDF');
      }
    });
  };

  return (
    <Box>
      <Text fw={500} size='sm' mb={2}>
        Archivo PDF <span style={{ color: 'red' }}>*</span>
      </Text>

      <Dropzone
        onDrop={onDrop}
        onReject={handleReject}
        accept={[MIME_TYPES.pdf]}
        maxSize={10 * 1024 ** 2} // 10MB
        multiple={false}
        styles={{
          root: {
            border: '2px dashed #c4c4c4',
            borderRadius: rem(8),
            padding: rem(20),
            textAlign: 'center',
          },
        }}
      >
        <Stack align="center" spacing="xs">
          <IconUpload size="1.8rem" color="#909296" />
          <Text c="dimmed" size="sm">
            Arrastra tu archivo PDF aquí o hacé clic para seleccionar
          </Text>
          <Text c="dimmed" size="xs">
            Tamaño máximo: 10 MB | Solo archivos PDF
          </Text>
          <Button
            variant="default"
            leftSection={<IconUpload size={16} />}
            mt="xs"
          >
            Seleccionar archivo
          </Button>
        </Stack>
      </Dropzone>
    </Box>
  );
}

export default DropzoneButton;
